<template>
  <v-container>
    <loading-spinner v-if="loading"> </loading-spinner>
    <template v-else>
      <survey-intro v-if="step == 0"></survey-intro>
      <survey-container v-else></survey-container>
    </template>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import SurveyContainer from "@/components/survey/SurveyContainer";
import SurveyIntro from "@/components/survey/SurveyIntro";
export default {
  name: "SurveyPreview",
  components: {
    "survey-container": SurveyContainer,
    "survey-intro": SurveyIntro
  },
  data: () => ({ loading: false }),
  computed: mapGetters({
    survey: "survey/survey",
    step: "survey/step"
  }),
  created() {
    this.$store.dispatch("survey/setIsPreview", true).then(() => {
      this.loading = true;
      Promise.all([
        this.$store.dispatch("survey/getSurvey", this.$route.params.id),
        this.$store.dispatch("profile/getProfile", {
          id: this.$route.params.id,
          is_preview: true
        })
      ]).then(() => {
        this.loading = false;
      });
    });
  }
};
</script>
